import styled from 'styled-components';

export default styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  margin-top: 22px;
  ${({ theme }) => theme.breakpoint('md')} {
    > button {
      margin-left: 16px;
    }
  }

  ${({ theme }) => theme.breakpoint('sm', 'md')} {
    width: inherit;
    margin-top: auto;
  }
`;
